const {
  getFixedImageObject,
  getFluidImageObject,
} = require('../gatsby-image/get-image-objects');

// Runtime APIs for fetching remote images on Cloudinary
module.exports = {
  getFixedImageObject,
  getFluidImageObject,
};
